export { default } from "./MenuSolutionBusiness";
